export enum DocumentTypes {
    SystemDocument = 1,
    TechDocumentation = 2,
    PurchaseNotice = 3,
    AdvanceAgreement = 4,
    DebtorGoodsSaleAgreement = 5,
    CopyOfExtractFromCompanyRegister = 6,
    CopyOfExtractFromIndividualEntrepreneurRegister = 7,
    CopyOfFoundingDocument = 8,
    CopyOfCertificateOfIdentity = 9,
    RegistrationDocumentsTranslation = 10,
    ChiefPermissionsDocuments = 11,
    ApprovalDecisionCopy = 12,
    ApplicantInterest = 13,
    // ArbitrationAdministratorCapitalContribution = 14,
    ApplicantInformation = 15,
    // SROAUInformation = 16, //
    CertificateOfRegistrationWithTheTaxAuthority = 17,
    BidsReport = 18,
    PartyDecisionProtocol = 19,
    ChoiceOfWinnerProtocol = 20,
    WinnerProtocol = 21,
    AuthorityDocument = 22,
    RetenderNotice = 23,
    RetenderProtocol = 24,
    RetenderEnvelopeProtocol = 25,
    RetenderChoiceOfWinnerProtocol = 26,
    PurchaseApplication = 27,
    ResultNotice = 28,
    ArchivesPartyDecisionProtocol = 29,
    CertificateOfRegistrationINN = 30,
    Image = 31,
    ClosedPurchaseParticipationComplience = 32,
    System = 33,
    Other = 34,
    ProtocolAIS_ERKT = 35,
    AuctionDecision = 36,
    TradeProtocol = 37,
    LotProtocol = 38,
    Agreement = 39,
    PurchaseParticipantsProtocol = 40,
    AuctionProtocol = 41,
    BusinessAgreement = 42,
    DebtorFeeActComWorks = 43,
    DebtorFeeInvoice = 44,
    DebtorFee = 45,
    DebtorFeeCover = 46,
    ReturnRegistrySingle = 47,
    ReturnRegistryMultiple = 48,
    PaymentDocument = 49,
    ContractOfSale = 50,
}

export var DocumentTypeTranslations: { [key: DocumentTypes]: string; } = {}; 
DocumentTypeTranslations[DocumentTypes.SystemDocument] = "Системный документ";
DocumentTypeTranslations[DocumentTypes.TechDocumentation] = "Техническая документация";
DocumentTypeTranslations[DocumentTypes.PurchaseNotice] = "Уведомление о закупке";
DocumentTypeTranslations[DocumentTypes.AdvanceAgreement] = "Договор авансирования";
DocumentTypeTranslations[DocumentTypes.DebtorGoodsSaleAgreement] = "Договор продажи имущества должника";
DocumentTypeTranslations[DocumentTypes.CopyOfExtractFromCompanyRegister] = "Копия выписки из реестра компаний";
DocumentTypeTranslations[DocumentTypes.CopyOfExtractFromIndividualEntrepreneurRegister] = "Копия выписки из реестра ИП";
DocumentTypeTranslations[DocumentTypes.CopyOfFoundingDocument] = "Копия учредительного документа";
DocumentTypeTranslations[DocumentTypes.CopyOfCertificateOfIdentity] = "Копия удостоверения личности";
DocumentTypeTranslations[DocumentTypes.RegistrationDocumentsTranslation] = "Перевод регистрационных документов";
DocumentTypeTranslations[DocumentTypes.ChiefPermissionsDocuments] = "Документы разрешения руководителя";
DocumentTypeTranslations[DocumentTypes.ApprovalDecisionCopy] = "Копия решения об утверждении";
DocumentTypeTranslations[DocumentTypes.ApplicantInterest] = "Заинтересованность заявителя";
DocumentTypeTranslations[DocumentTypes.ApplicantInformation] = "Информация о заявителе";
DocumentTypeTranslations[DocumentTypes.CertificateOfRegistrationWithTheTaxAuthority] = "Свидетельство о постановке на учет в налоговой";
DocumentTypeTranslations[DocumentTypes.BidsReport] = "Отчет о торгах";
DocumentTypeTranslations[DocumentTypes.PartyDecisionProtocol] = "Протокол решения стороны";
DocumentTypeTranslations[DocumentTypes.ChoiceOfWinnerProtocol] = "Протокол выбора победителя";
DocumentTypeTranslations[DocumentTypes.WinnerProtocol] = "Протокол победителя";
DocumentTypeTranslations[DocumentTypes.AuthorityDocument] = "Документ полномочий";
DocumentTypeTranslations[DocumentTypes.RetenderNotice] = "Уведомление о повторных торгах";
DocumentTypeTranslations[DocumentTypes.RetenderProtocol] = "Протокол повторных торгов";
DocumentTypeTranslations[DocumentTypes.RetenderEnvelopeProtocol] = "Протокол вскрытия конвертов повторных торгов";
DocumentTypeTranslations[DocumentTypes.RetenderChoiceOfWinnerProtocol] = "Протокол выбора победителя повторных торгов";
DocumentTypeTranslations[DocumentTypes.PurchaseApplication] = "Заявка на покупку";
DocumentTypeTranslations[DocumentTypes.ResultNotice] = "Уведомление о результатах";
DocumentTypeTranslations[DocumentTypes.ArchivesPartyDecisionProtocol] = "Протокол решения стороны (архив)";
DocumentTypeTranslations[DocumentTypes.CertificateOfRegistrationINN] = "Свидетельство о регистрации ИНН";
DocumentTypeTranslations[DocumentTypes.Image] = "Изображение";
DocumentTypeTranslations[DocumentTypes.ClosedPurchaseParticipationComplience] = "Соответствие участия в закрытых закупках";
DocumentTypeTranslations[DocumentTypes.System] = "Система";
DocumentTypeTranslations[DocumentTypes.Other] = "Другое";
DocumentTypeTranslations[DocumentTypes.ProtocolAIS_ERKT] = "Протокол АИС ЕРКТ";
DocumentTypeTranslations[DocumentTypes.AuctionDecision] = "Решение аукциона";
DocumentTypeTranslations[DocumentTypes.TradeProtocol] = "Торговый протокол";
DocumentTypeTranslations[DocumentTypes.LotProtocol] = "Протокол лота";
DocumentTypeTranslations[DocumentTypes.Agreement] = "Соглашение";
DocumentTypeTranslations[DocumentTypes.PurchaseParticipantsProtocol] = "Протокол участников закупки";
DocumentTypeTranslations[DocumentTypes.AuctionProtocol] = "Протокол аукциона";
DocumentTypeTranslations[DocumentTypes.BusinessAgreement] = "Бизнес-соглашение";
DocumentTypeTranslations[DocumentTypes.DebtorFeeActComWorks] = "Акт выполненных работ по вознаграждению должника";
DocumentTypeTranslations[DocumentTypes.DebtorFeeInvoice] = "Счет-фактура на вознаграждение должника";
DocumentTypeTranslations[DocumentTypes.DebtorFee] = "Вознаграждение должника";
DocumentTypeTranslations[DocumentTypes.DebtorFeeCover] = "Сопроводительный документ на вознаграждение должника";
DocumentTypeTranslations[DocumentTypes.ReturnRegistrySingle] = "Реестр возвратов (одиночный)";
DocumentTypeTranslations[DocumentTypes.ReturnRegistryMultiple] = "Реестр возвратов (множественный)";
DocumentTypeTranslations[DocumentTypes.PaymentDocument] = "Платежный документ";
DocumentTypeTranslations[DocumentTypes.ContractOfSale] = "Договор купли-продажи";